import { render, staticRenderFns } from "./AppNavigationDisabledCalendarIconBullet.vue?vue&type=template&id=073a91a1&"
import script from "./AppNavigationDisabledCalendarIconBullet.vue?vue&type=script&lang=js&"
export * from "./AppNavigationDisabledCalendarIconBullet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073a91a1')) {
      api.createRecord('073a91a1', component.options)
    } else {
      api.reload('073a91a1', component.options)
    }
    module.hot.accept("./AppNavigationDisabledCalendarIconBullet.vue?vue&type=template&id=073a91a1&", function () {
      api.rerender('073a91a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/CalendarList/AppNavigationDisabledCalendarIconBullet.vue"
export default component.exports